import React, { Fragment } from "react";
// import { Grid } from "@mui/material";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { MdEdit } from "react-icons/md";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import LinearProgress from "@material-ui/core/LinearProgress";
import { API_URL1 } from "../services/url";
import axios from "axios";
import { useState, useEffect } from "react";
import DeleteDriver from "./DeleteDriver";
import PeopleIcon from "@mui/icons-material/People";

const ViewDriver = () => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(100);
  const [Udata, setUdata] = useState([]);
  const [record, setRecord] = useState(false);
  const [pagination, setPagination] = useState(null);

  const fetchDrivers = async (currentPage = page, currentLimit = rowsPerPage) => {
    try {
      const response = await axios.get(
        `${API_URL1}trucker/driver/getDrivers?truck_company_id=${Number(
          localStorage.getItem("adminid")
        )}&page=${currentPage + 1}&limit=${currentLimit}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "content-type": "application/json",
          },
        }
      );

      if (response.data.trucks) {
        setUdata(response.data.trucks);
        setPagination(response.data.pagination);
        setRecord(true);
      } else {
        setUdata([]);
        setPagination(null);
        setRecord(true);
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
      setUdata([]);
      setPagination(null);
      setRecord(true);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchDrivers(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value);
    setrowsPerPage(newLimit);
    setPage(0);
    fetchDrivers(0, newLimit);
  };

  useEffect(() => {
    fetchDrivers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  return (
    <Fragment>
      {!record ? <LinearProgress /> : ""}
      {/* Header with icon, title, and Add button */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', marginTop: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 8, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', boxShadow: '0 8px 16px rgba(99,102,241,0.25)' }}>
            <PeopleIcon fontSize="small" />
          </div>
          <h1 style={{ margin: 0, fontWeight: 800, fontSize: 28, color: '#0f172a' }}>Drivers</h1>
        </div>
        <Link to="/adddriver">
          <Button
            style={{ padding: '10px 22px', color: '#ffffff', background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', border: 'none', borderRadius: '999px', boxShadow: '0 8px 16px rgba(99,102,241,0.25)', transition: 'all .2s ease' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)'; e.currentTarget.style.boxShadow = '0 10px 20px rgba(124,58,237,0.35)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'; e.currentTarget.style.boxShadow = '0 8px 16px rgba(99,102,241,0.25)'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Add Driver
          </Button>
        </Link>
      </div>
      {/*............................................................................................................................................. TRUCK TABLE */}
      {!record && Udata.length === 0 ? (
        <div style={{ marginLeft: "4%" }}> Loading.........</div>
      ) : Udata.length === 0 && record ? (
        <div style={{ marginLeft: "4%" }}>No Record Available</div>
      ) : (
        <Paper style={{ width: "96%", margin: "16px auto", border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)' }}>
          <TableContainer style={{ maxHeight: "60vh" }}>
            <Table stickyHeader aria-label="drivers table">
              <TableHead style={{ backgroundColor: "#f1f5f9" }}>
                <TableRow>
                  <TableCell align="center" style={{ backgroundColor: "#f1f5f9", color: "#0f172a", fontWeight: 800 }}>
                    Driver's Name
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", fontWeight: 800 }} align="center">
                    Default Truck
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", fontWeight: 800 }} align="center">
                    Truck/Traller type
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", fontWeight: 800 }} align="center">
                    Contact Number
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", fontWeight: 800 }} align="center">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody style={{ backgroundColor: "#ffffff" }}>
                {Udata &&
                  Udata.map((item, key) => (
                    <TableRow 
                      key={key} 
                      hover 
                      style={{ borderBottom: '1px solid #eef2f7' }}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell align="center">{item.name}</TableCell>
                      <TableCell align="center">
                        {" "}
                        {item.registration_number}
                      </TableCell>
                      <TableCell align="center">{item.type}</TableCell>
                      <TableCell align="center">{item.phone_no}</TableCell>

                      <TableCell align="center">
                        <Link
                          to={{
                            pathname: `/editDriver/${item.truck_company_user_id}/${item.truck_id}`,
                          }}
                        >
                          <MdEdit
                            style={{ color: "#0075ff", fontSize: "17px" }}
                            sx={{ ml: -2.5 }}
                            variant="none"
                          >
                            <ModeEditOutlineOutlinedIcon
                              sx={{ color: "#0075FF" }}
                            />
                          </MdEdit>
                        </Link>
                        <DeleteDriver data={item.truck_company_user_id} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={pagination ? pagination.totalItems : 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            style={{ fontSize: 16 }}
          />
        </Paper>
      )}
    </Fragment>
  );
};

export default ViewDriver;
